<template>
  <div class="navcontainer _navcontainer" @mouseover="subTitleShow = false" :class="{ 'sticky-nav': isSticky }">
    <div class="navicon _navicon"><i class="iconfont icon-caidan" @click="opencaidan()"></i></div>
    <div v-if="homeShow" class="appleicon _appleicon" @click="$router.push('/home')">
      <!--<img src="../../assets/nav/nav_logo_black.png" alt="Logo" width="44px">
      <img src="../../assets/nav/nav_logo_black.png" alt="Logo" width="44px">-->
      <img v-if="this.$i18n.locale == 'zh'" src="../../assets/logo/logo.png" alt="Logo" width="100%">
      <img v-if="this.$i18n.locale == 'en'" src="../../assets/logo/logo.png" alt="Logo" width="100%">
<!--      <span class="Logo-title" style="">LMLECC</span>-->
    </div>
    <!--    <div class="appleicon _appleicon"><i class="iconfont icon-pingguo" @click="$router.push('/home')"></i></div>-->
    <div id="navID" class="mainnavlist _mainnavlist">
<!--      <div class="navlistclose"><i @click="closecaidan()" class="iconfont icon-guanbi"></i></div>-->
<!--      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'" @click="routerpush('/home');" :class="activeRouter == '/home'?'activeDiv':'notActiveDiv'" @mouseover="showDropdown = false">{{$t('home.home')}}</div>-->
      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @click="activeRouterClick($t('home.aboutus'))" :class="activeRouter == '/summary' ? 'activeDiv' : 'notActiveDiv'"  :id="$t('home.aboutus')">{{$t('home.aboutUs')}}</div>
<!--      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @click="activeRouterClick($t('home.aboutus'))" :class="activeRouter == '/summary' ? 'activeDiv' : 'notActiveDiv'" @mouseover.stop="openDropdown($t('home.aboutus'))" :id="$t('home.aboutus')">{{$t('home.aboutUs')}}</div>-->
<!--      <div @click="routerpush('/summary');"  :class="activeRouter == $t('home.aboutus')?'activeDiv':'notActiveDiv'">{{$t('home.aboutUs')}}</div>-->
      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @click="activeRouterClick($t('home.activities'))" @mouseover.stop="openDropdown($t('home.activities'))" :class="activeRouter == $t('home.activities') ? 'activeDiv' : 'notActiveDiv'" :id="$t('home.activities')">
        {{$t('home.wantWeDo')}}
        <span v-if="hasSubmenu($t('home.activities'))" class="dropdown-arrow"> </span>
      </div>
      <!-- <div @click="activeRouterClick('Activities')" @mouseover="showDropdown = false" :class="activeRouter == '/eventsNews'?'activeDiv':'notActiveDiv'">EVENTS & NEWS</div> -->
      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @click="routerpush('/partners');" @mouseover="showDropdown = false" :class="activeRouter == '/partners' ? 'activeDiv' : 'notActiveDiv'">{{$t('home.partners')}}</div>
      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @click="activeRouterClick($t('home.downResource'));activeRouter =$t('home.downResource')" @mouseover.stop="openDropdown($t('home.downResource'))"  :class="activeRouter == '/cardNavigation' ? 'activeDiv' : 'notActiveDiv'" :id="$t('home.downResource')">
        {{$t('home.resource')}}
        <span v-if="hasSubmenu($t('home.downResource'))" class="dropdown-arrow"> </span>
      </div>
<!--      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @mouseover="showDropdown = false" :class="activeRouter == '/elearning' ? 'activeDiv' : 'notActiveDiv'">{{$t('home.eLearning')}}</div>-->
      <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:2vh'" @click="routerpush('/contact');" @mouseover="showDropdown = false" :class="activeRouter == '/contact' ? 'activeDiv' : 'notActiveDiv'">{{$t('home.contact')}}</div>
<!--      <div @click="routerpush('/support')">技术支持</div>-->
      </div>
      <div class="nav-actions">
        <div class="sousuo">
          <i class="iconfont icon-sousuo1" @click="openDropdown('sousuo')" style="font-size: 1.6em;cursor: pointer;"></i>
        </div>
        <div class="language-dropdown-container">
          <div class="languageButBox-effect language-selector" @click="toggleLanguageDropdown">
            <span class="language-icon">
              <svg t="1743312401136" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4641" width="18" height="18"><path d="M757.205333 473.173333c5.333333 0 10.453333 2.090667 14.250667 5.717334a19.029333 19.029333 0 0 1 5.888 13.738666v58.154667h141.184c11.093333 0 20.138667 8.704 20.138667 19.413333v232.704a19.797333 19.797333 0 0 1-20.138667 19.413334h-141.184v96.981333a19.754667 19.754667 0 0 1-20.138667 19.370667H716.8a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.888-13.696v-96.981333h-141.141333a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.930666-13.738667v-232.704c0-5.12 2.133333-10.112 5.930666-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h141.141333v-58.154667c0-5.162667 2.133333-10.112 5.888-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h40.362667zM192.597333 628.394667c22.272 0 40.32 17.365333 40.32 38.826666v38.741334c0 40.618667 32.512 74.368 74.624 77.397333l6.058667 0.213333h80.64c21.930667 0.469333 39.424 17.706667 39.424 38.784 0 21.077333-17.493333 38.314667-39.424 38.784H313.6c-89.088 0-161.28-69.461333-161.28-155.178666v-38.741334c0-21.461333 18.005333-38.826667 40.277333-38.826666z m504.106667 0h-80.64v116.394666h80.64v-116.394666z m161.28 0h-80.64v116.394666h80.64v-116.394666zM320.170667 85.333333c8.234667 0 15.658667 4.778667 18.773333 12.202667H338.773333l161.322667 387.84c2.517333 5.973333 1.706667 12.8-2.005333 18.090667a20.394667 20.394667 0 0 1-16.725334 8.533333h-43.52a20.181333 20.181333 0 0 1-18.688-12.202667L375.850667 395.648H210.901333l-43.264 104.149333A20.181333 20.181333 0 0 1 148.906667 512H105.514667a20.394667 20.394667 0 0 1-16.725334-8.533333 18.773333 18.773333 0 0 1-2.005333-18.090667l161.28-387.84A20.181333 20.181333 0 0 1 266.88 85.333333h53.290667zM716.8 162.901333c42.794667 0 83.84 16.341333 114.090667 45.44a152.234667 152.234667 0 0 1 47.232 109.738667v38.741333c-0.469333 21.077333-18.389333 37.930667-40.32 37.930667s-39.808-16.853333-40.32-37.930667v-38.741333c0-20.608-8.490667-40.32-23.637334-54.869333a82.304 82.304 0 0 0-57.045333-22.741334h-80.64c-21.888-0.469333-39.424-17.706667-39.424-38.784 0-21.077333 17.493333-38.314667 39.424-38.784h80.64z m-423.424 34.304L243.2 318.037333h100.48L293.418667 197.205333z" fill="#000000" p-id="4642"></path></svg>
            </span>
            <span class="language-text" v-if="this.$i18n.locale == 'en'">English</span>
            <span class="language-text" v-else>简体中文</span>
            <span class="dropdown-arrow" :class="{'dropdown-arrow-open': showLanguageDropdown}">▼</span>
          </div>
          <div v-show="showLanguageDropdown" class="language-dropdown-menu">
            <div class="language-option" @click="selectLanguage('zh')">
              简体中文
            </div>
            <div class="language-option" @click="selectLanguage('en')">
              English
            </div>
            <!-- 未来可以在这里添加更多语言选项 -->
            <!-- <div class="language-option" @click="selectLanguage('es')">Español</div> -->
            <!-- <div class="language-option" @click="selectLanguage('fr')">Français</div> -->
          </div>
        </div>
    </div>

    <!--@click='langToggle'-->
    <!--原来使用天气插件-->
    <!-- <div v-show="activeRouter !== '/home'&&this.$i18n.locale=='zh'" style="margin-left:0px;width: 12%;position: relative;top:100%;transform:translateY(-25%);" >
      <iframe style="width: 100%" frameborder="0" scrolling="no"  hspace="0" src="https://i.tianqi.com?c=code&id=26&icon=1&py=kunming&site=12" ></iframe>
    </div>
    <div v-show="activeRouter !== '/home'&&this.$i18n.locale=='en'" style="margin-left:0px;width: 12%;position: relative;top:0;transform:translateY(0%);" >
      <iframe style="width: 100%;"  frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=15&icon=1&py=kunming" ></iframe>
    </div> -->

<!--    <div  v-if="activeRouter !== '/home'&&this.$i18n.locale=='zh'" style="display: flex;font-size: 1.5vh;align-items: center;" >-->
<!--      <div style="padding-right: 0.6vh;">昆明</div>-->
<!--      <img :src="weatherImageUrl" width="25vh" height="25vh" />-->
<!--      <div  style="padding:0 0.5vh;">{{ weatherData.now.text }}</div>-->
<!--      <div  style="padding:0 0.9vh;color: #390;">{{ weatherData.now.temp }} ℃</div>-->
<!--    </div>-->
    <div  v-if="activeRouter !== '/home'&&this.$i18n.locale=='en'" style="display: flex;font-size: 1.5vh;align-items: center;" >
      <div style="padding-right: 0.7vh;font-weight: bold;">kunming</div>
      <img :src="weatherImageUrl" width="25vh" height="25vh" />
      <!-- <div  style="padding:0 0.5vh;">{{ weatherData.now.text }}</div> -->
      <div  style="padding:0 0.9vh;color: #390;">{{ weatherData.now.temp }} ℃</div>
    </div>
    <div :class="sousuoShow==true?'dropdown':'dropdown2'" v-if="showDropdown" @mouseover="subTitleShow = false" :style="sousuoShow==true?{}:{'top':divtop + 'px'}">
      <div v-if="sousuoShow" class="sousuo-box">
        <div class="sousuo-input">
          <i class="iconfont icon-sousuo" style="font-size: 25px"></i>
          <input type="text" class="search-input" v-model="search" @keyup="checkKey" :placeholder="$t('home.placeholder')" style="height: 35px">
        </div>
        <div class="sousuo-list">
          <p>{{$t('home.recommondedSearch')}}</p>
          <p>{{$t('home.content1')}}</p>
          <p>{{$t('home.content2')}}</p>
          <p>{{$t('home.content3')}}</p>
        </div>


      </div>
      <div v-if="subTitleShow" class="aboutUs-box" :style="{'margin-left':divleft+'px'}"  @mouseover.stop="subTitleShow = true" @mouseleave="showDropdown = false">
        <div class="subTitle-list">
          <p v-for="(item,index) in subTitleList.children" :key="index" @click="activeRouterClick2(subTitleList.title,index)">{{item.title}}</p>
        </div>
      </div>
      <!-- <div v-if="subTitleShow == 'aboutUs'" class="aboutUs-box" :style="{'margin-left':divleft+'px'}">
        <div class="subTitle">
          ABOUT US
        </div>
        <div class="subTitle-list">
          <p v-for="item in aboutUsList" >{{item.name}}</p>

        </div>


      </div>
      <div v-if="subTitleShow == 'whatWeDo'" class="aboutUs-box" :style="{'margin-left':divleft2+'px'}">
        <div class="subTitle">
          WHAT WE DO
        </div>
        <div class="subTitle-list">
          <p v-for="item in whatWeDoList" >{{item.name}}</p>

        </div>


      </div> -->
    </div>
  </div>
</template>

<script>

import {getNavTopTree,getWeatherData} from "@/api/navtop";
import axios from 'axios';
import cookie from "js-cookie";
export default {
  name: 'navtop',
  components: {},
  data() {
    return {
      activeHandleResizeName:"",//当前下拉菜单名称，用于避免下拉菜单出现时位置变化
      nalistshowflag: false,
      showDropdown: false,
      sousuoShow: false,
      homeShow: true,
      activeRouter:'',
      search:'',
      param:{
        id:"",
        pid:"",
      },
      id:"",
      pid:"",
      subTitleShow:false,
      subTitleList:{},
      divleft:'100',
      divleft2:'100',
      divtop:'100',
      titleTree:[],
      languages:"",
      weatherImageUrl:require('@/assets/img/天气-晴.png'),  //显示天气图标
      weatherData:{
        now:{
          text:'',
          temp:"",
        }
      },
      aboutUsList:[
        {
          name:'ORGANIZATION STRUCTURE'
        },
        {
          name:'NAME & LOGO'
        },
        {
          name:'HISTORY'
        },

      ],
      whatWeDoList:[
        {
          name:'JOINT ACTION'
        },
        {
          name:'JOINT PATROL'
        },
        {
          name:'CAPACITY BUILDING'
        },
        {
          name:'SCHOLARSHIP'
        },
        {
          name:'ACADEMY'
        },
        {
          name:'INTEGRATED COORDINATION & OPERATIONAL SUPPORT'
        },
      ],
      isSticky: false,
      showLanguageDropdown: false,
    }
  },
  created(){
    if(this.$i18n.locale == 'zh'){
      this.languages = '中文';
    }else{
      this.languages = 'ENGLISH';
    }
        this.$watch('$route', () => {
          this.activeRouter = this.$route.path
          let routerQuery = this.$route.query
          // 保持activeRouter为路径，确保模板中的路径比较正确工作
          // 不再将activeRouter设置为标题，以避免状态不一致
        //  window.location.href = window.location.href
        // this.init(); // 监听路由变化，重新加载数据
      });
      this.getWeatherData()//初始化天气数据
    },
  mounted(){
    this.getNavTopTree()
    //监听分辨率变化，避免下拉菜单位置变化
    let that = this
    window.addEventListener('resize',function () {
      if(that.activeHandleResizeName!=""){
        that.handleResize2(that.activeHandleResizeName);
        that.handleResize3(that.activeHandleResizeName)
      }
    } )
    // this.activeRouter = this.$router.currentRoute.path
    // this.handleResize()
    // window.addEventListener('resize',this.handleResize)

    // Add scroll event listener for sticky navigation
    window.addEventListener('scroll', this.handleScroll)

    // Add click outside listener
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy(){
    // window.removeEventListener('resize',this.handleResize)
    let that = this
    window.removeEventListener('resize',function () {
      if(that.activeHandleResizeName!=""){
        that.handleResize2(that.activeHandleResizeName);
        that.handleResize3(that.activeHandleResizeName)

      }
    } )
    window.removeEventListener('scroll', this.handleScroll)

    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    langToggle(){
      if(this.$i18n.locale == 'zh'){
        this.$i18n.locale = 'en';
        cookie.set("lang",'en')
      }else{
        this.$i18n.locale = 'zh';
        cookie.set("lang",'zh')
      }
      this.$router.push('/home')
      window.location.reload();
    },
    //初始化获取天气信息
    getWeatherData(){
      getWeatherData().then(res=>{
        this.weatherData = res.data.result
        //判断图片文件夹中是否含有该天气对应的图标
        let url = './天气-'+res.result.now.text+'.png'
        let flag = false
        const files = require.context('@/assets/img/', false, /\.png$/)
        const filedata = files.keys()
        // 判断是否有该文件
        filedata.forEach((item) => {
          if (item === url) {
            flag = true
          }
        })
        //若有该天气图标直接放上，否则进行判断
        if(flag){
          this.weatherImageUrl = require('@/assets/img/天气-'+res.result.now.text+'.png')
        }else if( res.result.now.text == "大暴雨到特大暴雨"){
          this.weatherImageUrl = require('@/assets/img/天气-特大暴雨.png')
        }else if( res.result.now.text == "龙卷风"){
          this.weatherImageUrl = require('@/assets/img/天气-沙尘暴.png')
        }else if( res.result.now.text.indexOf('雪') !== -1){
          this.weatherImageUrl = require('@/assets/img/天气-雪.png')
        }else if( res.result.now.text.indexOf('雾') !== -1){
          this.weatherImageUrl = require('@/assets/img/天气-雾.png')
        }else if( res.result.now.text.indexOf('霾') !== -1){
          this.weatherImageUrl = require('@/assets/img/天气-霾.png')
        }else{
          this.weatherImageUrl = require('@/assets/img/天气-阴.png')
        }
        // if(res.result.now.text == '晴'){
        //   this.weatherImageUrl = require('@/assets/img/天气-晴.png')
        // }else if(res.result.now.text == '多云'){
        //   this.weatherImageUrl = require('@/assets/img/天气-多云.png')
        // }else if(res.result.now.text == '阴'){
        //   this.weatherImageUrl = require('@/assets/img/天气-阴.png')
        // }else if(res.result.now.text == '阵雨'){
        //   this.weatherImageUrl = require('@/assets/img/天气-多云.png')
        // }
      })
    },
    getNavTopTree(){

      getNavTopTree().then(res=>{
        this.titleTree = res.data[0]
        sessionStorage.setItem('titleTree',JSON.stringify(this.titleTree))
        this.activeRouter = this.$route.path
        let routerQuery = this.$route.query
        if(this.activeRouter == '/navigation' || this.activeRouter == '/detail'){
          this.titleTree.children.forEach((item,index) => {
                  if(item.data.id == routerQuery.pid || item.data.id == routerQuery.id){
                    this.activeRouter = item.title
                  }
              });
        }
      })
    },
    activeRouterClick(title){
      console.log('title'+title)
      if(title=="关于中心" || title=="About us"){
        this.$router.push({
          path: '/summary',
        })
      }else if(title == "资源分享" || title == "Download Resouces"){
        this.param.pid = ""  //一级菜单id
        this.param.id = ""  //二级菜单id
        this.titleTree.children.forEach((item,index) => {
          if(item.title == title){
            this.param.id = item.data.id
            this.param.pid = item.data.columnPid
          }
        });
        this.$router.push({
          path: '/cardNavigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
          }
        })
      }
      else{
        this.param.pid = ""  //一级菜单id
        this.param.id = ""  //二级菜单id
        this.titleTree.children.forEach((item,index) => {
          if(item.title == title){
            this.param.id = item.data.id
            this.param.pid = item.data.columnPid
          }
        });
        this.$router.push({
          path: '/navigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
          }
        })
      }
      var dom = document.getElementById('navID')
      if (dom.classList.contains('navlistshow')) {
        this.subTitleShow = false
        dom.classList.remove('navlistshow')
      }
    },
    activeRouterClick2(title,index){
      // this.activeRouter = title
      this.param.pid = ""  //二级菜单id
      this.param.id = ""  //三级菜单id
      this.param.pid = this.subTitleList.children[index].data.columnPid
      this.param.id = this.subTitleList.children[index].data.id

      if(title=="关于中心" || title=="About us"){
        this.$router.push({
          path: '/summary',
          query: {
            index: index,
          }
        })
      }else if(title == "资源分享"&&index===0||title == "资源分享"&&index===1 || title == "Download Resouces"&&index===0||title == "Download Resouces"&&index===1){
        this.$router.push({
          path: '/cardNavigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
          }
        })
      }
      else{
        this.$router.push({
          path: '/navigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
          }
        })
      }
    },
    handleResize(){
          // if(this.subTitleShow == "aboutUs"){
            // 假设你有一个元素的ID是'myElement'
            const element = document.getElementById('aboutUs');

            // 获取元素的左上角相对于视口的位置
            const rect = element.getBoundingClientRect();

            // 获取元素的左边界距离视口左边界的距离
            const offsetWidthFromLeft = rect.left;
            // let height = this.$refs.videoPlayerBox.offsetHeight
            this.divleft = offsetWidthFromLeft
          // }else if(this.subTitleShow == "whatWeDo"){
            // 假设你有一个元素的ID是'myElement'
            const element2 = document.getElementById('whatWeDo');

            // 获取元素的左上角相对于视口的位置
            const rect2 = element2.getBoundingClientRect();

            // 获取元素的左边界距离视口左边界的距离
            const offsetWidthFromLeft2 = rect2.left;
            // let height = this.$refs.videoPlayerBox.offsetHeight
            this.divleft2 = offsetWidthFromLeft2
          // }

    },
    handleResize2(name){
          this.activeHandleResizeName = name
          // if(this.subTitleShow == "aboutUs"){
            // 假设你有一个元素的ID是'myElement'
            const element = document.getElementById(name);
            // 获取元素的左上角相对于视口的位置
            const rect = element.getBoundingClientRect();
            // 获取元素的左边界距离视口左边界的距离
            const offsetWidthFromLeft = rect.left;
            // let height = this.$refs.videoPlayerBox.offsetHeight
            this.divleft = offsetWidthFromLeft
    },
    //监测菜单上偏移
    handleResize3(name){
        // 假设你有一个元素的ID是'myElement'
        const element = document.getElementById(name);
        // 获取元素的左上角相对于视口的位置
        const rect = element.getBoundingClientRect();
        // 获取元素的左边界距离视口左边界的距离
        const offsetWidthFromTop = rect.top;
        // let height = this.$refs.videoPlayerBox.offsetHeight
        const height = element.clientHeight
        this.divtop = offsetWidthFromTop + height

    },
    home(){
      this.homeShow = false
    },
    routerpush(to) {
      this.$router.push(to)
      // this.showDropdown = true
      // 跳转之后，记得关闭菜单（在屏幕宽度小于800的时候才生效）
      var dom = document.getElementById('navID')
      if (dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
      }
    },
    openDropdown(name) {
      this.sousuoShow = false
      this.showDropdown = true
      this.subTitleShow = false
      var dom = document.getElementById('navID')
      if(name === 'sousuo'){
        this.sousuoShow = false
        this.$router.push({
          path: '/search',
          query: {
            key: this.search,
          }
        })
        if (dom.classList.contains('navlistshow')) {
          this.$router.push({
            path: '/search',
            query: {
              key: this.search,
            }
          })
          this.sousuoShow = false
          dom.classList.remove('navlistshow')
        }
      }else{
        this.subTitleShow = true
        this.handleResize2(name)
        this.handleResize3(name)
        if(this.titleTree.children!=null){
          this.titleTree.children.forEach((item,index) => {
            if(item.title == name){
              this.subTitleList = item
            }
          });
        }
      }
      if (dom.classList.contains('navlistshow')) {
        this.sousuoShow = false
      }

    },
    checkKey(event) {
      if (event.key === 'Enter') {
        this.$router.push({
          path: '/search',
          query: {
            key: this.search,
          }
        })
      }
    },
    // 当屏幕宽度小于800的时候，点击菜单图标，显示隐藏的菜单
    opencaidan() {
      var dom = document.getElementById('navID')

      if (dom.classList.contains('navlistshow')) {
        return
      }
      dom.classList.add('navlistshow')
    },
    // 当屏幕宽度小于800的时候，点击关闭按钮， 关闭菜单
    closecaidan() {
      var dom = document.getElementById('navID')
      if (dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
      }
    },
    // Check if a menu item has submenus
    hasSubmenu(title) {
      if (!this.titleTree || !this.titleTree.children) return false

      const menuItem = this.titleTree.children.find(item => item.title === title)
      return menuItem && menuItem.children && menuItem.children.length > 0
    },

    // Handle scroll event for sticky navigation
    handleScroll() {
      const scrollPosition = window.scrollY
      this.isSticky = scrollPosition > 0
    },
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    selectLanguage(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        cookie.set("lang", locale);
        this.$router.push('/home');
        window.location.reload();
      }
      this.showLanguageDropdown = false;
    },
    handleClickOutside(event) {
      const container = document.querySelector('.language-dropdown-container');
      if (container && !container.contains(event.target)) {
        this.showLanguageDropdown = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* ====== 桌面端样式 (大于800px) ====== */
@media only screen and (min-width: 800px) {
  .navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    height: 10vh;
    min-height: 70px;
    max-height: 90px;
    background-color: rgb(255, 255, 255);
    color: #333333;
    padding: 0 2vw;
    justify-content: space-between;
    position: relative;
    transition: all 0.3s ease;

    .navicon {
      display: none;
      cursor: pointer;
    }

    .navicon:hover {
      color: #111111;
    }

    .appleicon {
      width: 15%;
      min-width: 120px;
      max-width: 180px;
      cursor: pointer;
      display: flex;
    }

    .appleicon:hover {
      color: #111111;
    }

    .mainnavlist {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 70%;
      gap: 3.5vw;
      max-gap: 50px;
      margin: 0;

      .navlistclose {
        display: none;
      }

      div {
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        font-size: clamp(14px, 1.8vh, 18px);
        font-weight: 600;
        font-family: SourceHanSansCN, SourceHanSansCN;
        padding: 0.5rem 0;
        transition: color 0.3s ease;
      }

      div:hover {
        color: #00AEEF;
      }


    }

    .nav-actions {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      min-width: 140px;
      justify-content: flex-end;
    }

    .sousuo {
      i {
        transition: color 0.3s ease;
        color: #333333;

        &:hover {
          color: #00AEEF;
        }
      }
    }

    .shopcar {
      cursor: pointer;
      font-size: 1vh;
    }

    .shopcar:hover {
      color: #111111;
    }

    .languageButBox-effect {
      transition: color 0.3s ease;
    }

    .languageButBox-effect:hover {
      color: #626360 !important;
    }

    .but {
      /*width: 50%;*/
      height: 24px;
      border-radius: 8px;
      /*border: 1px solid #333333;*/
      background-color: rgba(255, 255, 255, 0);
    }

    .Logo-title{
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 500;
      font-size: 28px;
      color: #333333;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      margin-left: 10px;
    }

    .dropdown {
      position: absolute;
      top: 10vh;
      left: 0;
      width: 100%;
      background-color: rgb(255, 255, 255);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      display: flex;

      .sousuo-box {
        //display: flex;
        //align-items: center;
        //justify-content: center;
        height: 100%;
        width: 400px;
        margin-left: 20%;

        .sousuo-input {
          position: relative;
          display: inline-block;
          align-items: center; /* 注意：align-items 在 inline-block 或 block 级别元素上通常不起作用，这里主要是为了说明意图 */
        }

        .sousuo-input i {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 30px;
          color: #706e6e;
        }

        .sousuo-input input {
          height: 40px;
          border: 1px solid transparent; /* 设置为透明边框 */
          padding-left: 30px; /* 为图标留出空间 */
          /* 可以添加更多样式，如圆角等 */
          border-radius: 4px; /* 示例：添加圆角边框 */
        }

        .search-input {
          height: 45px;
          border: 1px solid transparent; /* 初始边框设置为透明 */
          padding-left: 40px; /* 根据图标大小调整 */
          /* 移除焦点时的边框 */
          outline: none; /* 移除浏览器默认的焦点轮廓 */
          box-shadow: none; /* 防止某些浏览器在获得焦点时添加阴影 */
          font-size: 20px;

        }

        .sousuo-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-top: 10px;
          margin-left: 15%;

          p {
            text-align: left; /* 确保文字左对齐 */
            padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 13px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
          }
        }


      }

      .aboutUs-box{
        background-color: #ffffff;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        .subTitle-list {
          color: #999;
          cursor: pointer;

          p {
            text-align: left;
            font-size: clamp(14px, 1.8vh, 18px);
            margin: 0;
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 2.5rem;
            padding: 0.5rem 1rem;
            border-radius: 6px;
            transition: all 0.3s ease;
          }

          p:hover {
            color: white;
            background-color: #00AEEF;
            transform: translateX(5px);
          }
        }
      }
      .whatWeDo-box{
        height: 100%;
        width: 400px;
        margin-left: 20%;
        .subTitle{
          color: rgba(110, 110, 115, 1);
          font-size: 16px;
          font-family: SourceHanSansCN-Regular;
          font-weight: normal;
          text-align: left;
          line-height: 24px;
          margin-left: 12.5%;
        }
        .subTitle-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-left: 12.5%;

          p {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }

          p:hover {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            color: rgba(0, 112, 255, 1);
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }
        }
      }
    }
    .dropdown2{
      //display: none;
      position: absolute;
      // top: 70px;
      left: 0;
      width: 100%;
      // height: 220px;
      z-index: 1000;
      display: flex;

      .sousuo-box {
        //display: flex;
        //align-items: center;
        //justify-content: center;
        height: 100%;
        width: 400px;
        margin-left: 20%;

        .sousuo-input {
          position: relative;
          display: inline-block;
          align-items: center; /* 注意：align-items 在 inline-block 或 block 级别元素上通常不起作用，这里主要是为了说明意图 */
        }

        .sousuo-input i {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 30px;
          color: #706e6e;
        }

        .sousuo-input input {
          height: 40px;
          border: 1px solid transparent; /* 设置为透明边框 */
          padding-left: 30px; /* 为图标留出空间 */
          /* 可以添加更多样式，如圆角等 */
          border-radius: 4px; /* 示例：添加圆角边框 */
        }

        .search-input {
          height: 45px;
          border: 1px solid transparent; /* 初始边框设置为透明 */
          padding-left: 40px; /* 根据图标大小调整 */
          /* 移除焦点时的边框 */
          outline: none; /* 移除浏览器默认的焦点轮廓 */
          box-shadow: none; /* 防止某些浏览器在获得焦点时添加阴影 */
          font-size: 20px;

        }

        .sousuo-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-top: 10px;
          margin-left: 15%;

          p {
            text-align: left; /* 确保文字左对齐 */
            padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 13px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
          }
        }


      }

      .aboutUs-box{
        background-color: rgb(255, 255, 255);
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        .subTitle-list {
          color: #999;
          cursor: pointer;

          p {
            text-align: left;
            font-size: clamp(14px, 1.8vh, 18px);
            margin: 0;
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 2.5rem;
            padding: 0.5rem 1rem;
            border-radius: 6px;
            transition: all 0.3s ease;
          }

          p:hover {
            color: white;
            background-color: #00AEEF;
            transform: translateX(5px);
          }
        }
      }
      .whatWeDo-box{
        height: 100%;
        width: 400px;
        margin-left: 20%;
        .subTitle{
          color: rgba(110, 110, 115, 1);
          font-size: 16px;
          font-family: SourceHanSansCN-Regular;
          font-weight: normal;
          text-align: left;
          line-height: 24px;
          margin-left: 12.5%;
        }
        .subTitle-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-left: 12.5%;

          p {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }

          p:hover {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            color: rgba(0, 112, 255, 1);
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }
        }
      }
    }

  }
  .activeDiv{
    color: #00AEEF;
  }
  .notActiveDiv{
    color: #333333;
  }
}

/* ====== 移动端样式 (小于800px) ====== */
@media only screen and (max-width: 800px) {
  ._navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    min-height: 60px;
    background-color: rgb(51, 51, 51);
    color: rgb(214, 214, 214);
    position: relative;
    padding: 0 1rem;

    ._navicon {
      width: 60px;
      display: flex;
      justify-content: center;
    }
    .iconfont {
      font-size: 24px;
    }

    ._appleicon {
      width: 120px;
      flex-shrink: 0;
    }

    ._mainnavlist {
      display: flex;
      flex-direction: column;
      position: absolute;
      //屏幕宽度小于800，默认清空下菜单是关闭的
      display: none;
      position: fixed;
      left: 0;
      top: 0 !important;
      z-index: 1999 !important;
      padding-top: 40px !important;
      width: 100%;
      height: 100%;
      color: rgb(214, 214, 214);
      background-color: rgba(0, 0, 0, 0.95);
      top: 40px;
      padding: 0 40px;
      z-index: 999;

      div {
        text-align: center;
        height: 40px;
        line-height: 40px;
        width: 100%;
        border-bottom: 1px solid rgb(214, 214, 214);
      }
    }

    .shopcar {
      width: 30%;
    }
  }

  .navlistshow {
    display: block !important;
  }
  .activeDiv{
    color: #1c31a2;
  }
  .notActiveDiv{
    color: rgb(214, 214, 214);
  }
}

/* ====== 粘性导航栏样式 ====== */
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* ====== 下拉箭头样式 ====== */
.dropdown-arrow {
  display: inline-block;
  margin-left: 1px;
  font-size: 0.8em;
  transition: transform 0.3s ease;
}

/* Rotate arrow when dropdown is open */
.activeDiv .dropdown-arrow {
  transform: rotate(180deg);
}

/* ====== 语言切换器样式 ====== */
.language-dropdown-container {
  position: relative;
  display: inline-block;
}

.language-selector {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  font-size: clamp(12px, 1.6vh, 16px);
  transition: background-color 0.3s ease;
}

.language-selector:hover {
  background-color: rgba(0, 174, 239, 0.1);
}

.language-icon {
  display: flex;
  align-items: center;
  margin-right: 0.4rem;
}

.language-text {
  font-size: clamp(12px, 1.6vh, 16px);
  display: flex;
  align-items: center;
  font-weight: 500;
  margin-right: 0.3rem;
}

.dropdown-arrow {
  font-size: 10px;
  margin-left: 5px;
  transition: transform 0.3s;
}

.dropdown-arrow-open {
  transform: rotate(180deg);
}

.language-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  z-index: 1001;
  color: #1e1f1b;
}

.language-dropdown-menu:hover{
  color: #626360 !important;
}

.language-option {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.language-option:hover{
  color: #626360 !important;
  background-color: #dfdfe3;
}

.languageButBox-effect:hover {
  color: #626360 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/comcomponents/NavTop.vue